import { render, staticRenderFns } from "./ChatECardV2.vue?vue&type=template&id=7463097f&scoped=true"
import script from "./ChatECardV2.vue?vue&type=script&lang=js"
export * from "./ChatECardV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463097f",
  null
  
)

export default component.exports